import React from "react";
import {getOrderSummaryDetails, getOrderSummaryPageByIds, getOrderSummaryPageByKey} from '../../accessors/GraphQLAccessor';
import OrderDetailLoading from './OrderDetailLoading';

import appMetrics from '../../common/MetricsService';
import MetricsConstants from '../../common/MetricsConstants';
import * as KatalMetrics from '@amzn/katal-metrics';
import { AppContext } from "../../AppContext";
import OrderDetailV2 from "./OrderDetailV2";
import { PAYMENT_METHOD_UPDATE } from "../../common/Constants";
import OrderDetailPillPackCom from "./OrderDetailPillPackCom";

class OrderDetailHOCV2 extends React.Component<any, any> {
  

  constructor(props: any) {
    super(props);
    this.state = {
      deliveryID: null,
      view: <OrderDetailLoading/>,
      paymentMethodUpdated: false,
    }
  }

  componentDidMount() {
    const paymentMethodUpdated = window.sessionStorage.getItem(PAYMENT_METHOD_UPDATE) === 'true';
    window.sessionStorage.removeItem(PAYMENT_METHOD_UPDATE);
    const actionMetricsPublisher = appMetrics.getMetricsPublisherForMethod("OrderDetail");
    const attemptMetric = new KatalMetrics.Metric.TimedAttempt(MetricsConstants.METRIC_LOAD_PAGE_DATA).withMonitor();

    const { orderKey, orderId, purchaseId } = this.props.match.params;

    const getOrderSummaryPageData = purchaseId 
        ? () => getOrderSummaryPageByIds(orderId, purchaseId)
        : () => getOrderSummaryPageByKey(orderKey);

    getOrderSummaryPageData()
      .then((response: any) => {
        // Different queries returns different names for orderSummaryPage object. Standardize it
        const orderSummaryPage = response.data.orderSummaryPageByIds || response.data.orderSummaryPage;
        
        const isPillPackComOrder = orderSummaryPage.isPillPackComOrder;
        
        // Subcomponents and pages require an orderKey. If we have the orderKey on the frontend,
        // We can use it. Otherwise, use the version retrieved from backend.
        // Note that orderKeyListString does not exist for PillPackCom cases, which will always use orderKey
        const passedUrlOrderKey = orderKey ? orderKey : orderSummaryPage.orderKeyListString;

        const OrderSummaryPageType = isPillPackComOrder
            ? OrderDetailPillPackCom
            : OrderDetailV2;
        this.setState({
          view: <OrderSummaryPageType urlId={passedUrlOrderKey}
          orderSummaryPage={orderSummaryPage}
          paymentMethodUpdated={paymentMethodUpdated}/>
        });
        attemptMetric.setSuccess();
        actionMetricsPublisher.publish(attemptMetric);
      })
      .catch((error) => {
        this.setState({
          view: (<pui-text id="order-detail-page-error" data-csa-c-content-id="order-detail-page-error" data-csa-c-type="card" data-csa-c-slot-id="order-detail">Error</pui-text>),
        });
        attemptMetric.setFailure();
        actionMetricsPublisher.publish(attemptMetric);
      });
  }

  render() {
    return (this.state.view);
  }
}

OrderDetailHOCV2.contextType = AppContext;

export default OrderDetailHOCV2

